export default class ApiResponse {
  success = false;
  errorCode = 200
  body = {};

  constructor(s, b, e = 200) {
    this.success = s
    this.body = b
    this.errorCode = e
  }

  getBody() {
    return this.body
  }

  getErrorCode() {
    return this.errorCode
  }
}
